import { autoUpdate, flip, offset, shift, useFloating } from '@floating-ui/react-dom';

interface SetupMenuFloatingParams {
  popperElement: HTMLElement | null;
  referenceElement: HTMLElement | null;
  isInfinityMode?: boolean;
}

/**
 * Hook that sets up floating menu positioning using Floating UI
 * @param params Object containing popper element, reference element, and infinity mode flag
 * @returns Floating UI configuration object
 */
export const useSetupMenuFloating = ({
  popperElement,
  referenceElement,
  isInfinityMode,
}: SetupMenuFloatingParams) => {
  return useFloating({
    elements: {
      floating: popperElement,
      reference: referenceElement,
    },
    placement: 'right',
    strategy: 'fixed',
    middleware: [
      offset(({ rects }) => {
        // When in "infinity" mode, the menu should be centered above the "reference" element
        if (isInfinityMode) {
          return {
            mainAxis: -0.5 * (rects.floating.width + rects.reference.width),
          };
        }

        // By default, the menu should be placed to the right of the "reference" element, slightly overlapping it
        return {
          mainAxis: -8,
        };
      }),
      shift({ padding: 8 }),
      flip(),
    ],
    whileElementsMounted: autoUpdate,
  });
};
